module.exports = __webpack_public_path__ + "static/media/15import.5ed1230a.xlsx";